import PropTypes from 'prop-types';

export const DataPropTypes = {
	PAID: PropTypes.shape({ total: PropTypes.number }),
	FORECAST: PropTypes.shape({ total: PropTypes.number }),
};
